import { Link } from 'react-router-dom';

export default function AboutSection() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid grid-cols-1 md:grid-cols-2 gap-16 items-center">
          {/* Image */}
          <div className="relative">
            <div className="relative rounded-2xl overflow-hidden h-96">
              <img
                src="https://readdy.ai/api/search-image?query=elegant%20Japanese%20beauty%20company%20office%20interior%20minimal%20clean%20white%20light%20blue%20accent%20flowers%20desk%20professional%20feminine%20aesthetic&width=600&height=500&seq=about1&orientation=portrait"
                alt="合同会社リンク"
                className="w-full h-full object-cover object-top"
              />
              <div className="absolute inset-0 bg-sky-400/5"></div>
            </div>
            {/* Ribbon accent */}
            <div className="absolute -top-4 -right-4 w-24 h-24 opacity-40 pointer-events-none">
              <svg viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
                <path d="M50 50 C30 30, 5 40, 10 55 C15 70, 40 60, 50 50Z" fill="#BAE6FD" />
                <path d="M50 50 C70 30, 95 40, 90 55 C85 70, 60 60, 50 50Z" fill="#7DD3FC" />
                <ellipse cx="50" cy="50" rx="8" ry="7" fill="#38BDF8" />
              </svg>
            </div>
          </div>

          {/* Text */}
          <div>
            <span className="text-sky-400 text-xs font-medium tracking-widest uppercase">About Us</span>
            <h2 className="text-3xl md:text-4xl font-light text-slate-800 mt-3 mb-6" style={{ fontFamily: "'Noto Serif JP', serif" }}>
              会社<span className="font-semibold">概要</span>
            </h2>
            <div className="w-12 h-0.5 bg-sky-300 mb-8"></div>

            <div className="space-y-5 text-sm text-slate-600 leading-relaxed">
              <p>
                合同会社リンクは、美容業界に特化したマーケティング支援・コンサルティング・教育事業を展開する会社です。
              </p>
              <p>
                美容に関する深い専門知識と、最新のマーケティング手法を組み合わせることで、クライアントのビジネス成長を力強くサポートします。
              </p>

              <div className="bg-sky-50 rounded-xl p-5 space-y-3">
                {[
                  { label: '会社名', value: '合同会社リンク' },
                  { label: '設立', value: '令和6年11月13日' },
                  { label: '所在地', value: '東京都豊島区南長崎三丁目7番6号\nグランエッグス落合07号' },
                  { label: '事業内容', value: '美容関連製品・サービスのマーケティング支援、情報提供・コンサルティング、オンライン講座・セミナーの企画・運営' },
                ].map((item) => (
                  <div key={item.label} className="flex gap-4">
                    <span className="text-sky-400 font-medium w-20 flex-shrink-0">{item.label}</span>
                    <span className="text-slate-600 whitespace-pre-line">{item.value}</span>
                  </div>
                ))}
              </div>
            </div>

            <Link
              to="/about"
              className="inline-flex items-center gap-2 mt-8 text-sky-400 text-sm font-medium hover:text-sky-500 transition-colors cursor-pointer"
            >
              詳しく見る
              <i className="ri-arrow-right-line"></i>
            </Link>
          </div>
        </div>
      </div>
    </section>
  );
}
